import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type SearchFilterKeys = "selectFilter" | "selectFilterText";
type SearchFilterActionType = {
    key: SearchFilterKeys;
    value: string;
};
type HandlerType = CustomHandler<SearchFilterActionType>;

export const SetTermFilter: HandlerType = props => {
    props.dispatch({ type: "Custom/Terms/SetSearchFilter", filters: props.parameter });
};

export const chain = [SetTermFilter];

const setTermSearchFilter = createHandlerChainRunner(chain, "SetTermSearchFilter");
export default setTermSearchFilter;
